module.exports = require('./helpers/bundle-url').getBundleURL('hcTqB') + "Stars.bca88cd6.png";